import DashBordScreen from "overrides/theme/wom/base/Pages/HomeScreens/HomeScreen/DashBoardScreen"
import OrderScreen from "overrides/theme/wom/base/Pages/OrderScreens/OrderScreen"
import ProfileScreen from "pages/UserScreens/ProfileScreen/ProfileScreen"
import ReportPage from "pages/Report/ReportPage"
import TransferScreen from "pages/TransferScreens/TransferScreen"
import ConfirmOrderScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Confirm/ConfirmOrderScreen"
import PackageScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Package/PackageScreen"
import DeliveryScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Delivery/DeliveryScreen"
import TransitScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Transit/TransitScreen"
import TransitReversaScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/TransitReversa/TransitReversaScreen"
import PickupScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Pickup/PickupScreen"
import DeliveredScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Delivered/DeliveredSreen"
import ReversaScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Reversa/ReversaScreen"
import ErrorHandler from "components/Commons/Error/ErrorHandler"
import { IRouteComponent } from "interfaces/IRoute"
import { validateAccessRouteOrder } from "helpers/validationRoutesHelper"
import ClosedScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Closed/ClosedScreen"
import CanceledScreen from "pages/DetailOrderScreens/Canceled/CanceledScreen"
import SearchResultsScreen from "overrides/theme/wom/base/Pages/SearchResults/SearchResultsScreen"
import ContractorSearchResultsScreen from "overrides/theme/wom/base/Pages/Contractor/SearchResults/SearchResultsScreen"
import { EShippinggroupStatus } from "enums/shippinggroupEmun"
import OrderDetailScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/Custom/OrderDetailScreen"
import ManifestScreen from "pages/ManifestScreens/ManifestScreen"
import ContractorDashboardScreen from "overrides/theme/wom/base/Pages/Contractor/Dashboard/ContractorDashboardScreen"
import ContractorSubStatusScreen from "overrides/theme/wom/base/Pages/Contractor/SubStatus/ContractorSubStatusScreen"
import ContractorOrderScreen from "overrides/theme/wom/base/Pages/Contractor/OrderScreens/ContractorOrderScreen"
import ContractorReceptionNewScreen from "overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Reception/New/NewSreen"
import ContractorReceptionOtherScreen from "overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Reception/Other/OtherSreen"
import ContractorInstallationNewScreen from "overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/New/NewSreen"
import ContractorInstallationIncompleteScreen from "overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/Incomplete/IncompleteSreen"
import ContractorInstallationCompleteScreen from "overrides/theme/wom/base/Pages/Contractor/DetailOrderScreens/Installation/Complete/CompleteSreen"
import PickupReservaScreen from "overrides/theme/wom/base/Pages/DetailOrderScreens/PickupReserva/PickupReservaScreen"
/*
import { useContext, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { AuthContext } from "context/context/AuthContext"
import { ResourceRoleEnum } from "enums/ResourceRoleEnum"
import React from "react"
*/

// Componente de redirección para usuarios contratistas
/*const ContractorRedirectWrapper: React.FC<any> = (props) => {
  const { state: { user } } = useContext(AuthContext)
  const history = useHistory()
  
  useEffect(() => {
    if (user?.role === ResourceRoleEnum["webapp-contractor-source"]) {
      history.push('/contractor-dashboard')
    }
  }, [user, history])

  return <DashBordScreen {...props} />
}*/

const RouteListWom: IRouteComponent[] = [
  {
    path: "/",
    name: "DashBordScreen",
    component: DashBordScreen, //ContractorRedirectWrapper
    exact: true,
  },
  {
    path: "/dashboard",
    name: "DashBordScreen",
    component: DashBordScreen, //ContractorRedirectWrapper
    exact: true,
  },
  {
    path: "/profile",
    name: "ProfileScreen",
    component: ProfileScreen,
    exact: true,
  },
  {
    path: "/order/:type",
    name: "OrderPage",
    component: OrderScreen,
    exact: true,
    handleValidateParams: validateAccessRouteOrder,
    redirectPath: "/",
  },
  {
    path: "/order/reversas/:type",
    name: "OrderReversaPage",
    component: OrderScreen,
    exact: true,
    handleValidateParams: validateAccessRouteOrder,
    redirectPath: "/",
  },
  {
    path: ["/order/confirmation/:shippingGroupId/:id"],
    name: "oderDetailConfrim",
    component: ConfirmOrderScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.confirmation,
  },
  {
    path: ["/order/package/:shippingGroupId/:id"],
    name: "oderDetailPackage",
    component: PackageScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.package,
  },
  {
    path: ["/order/delivery/:shippingGroupId/:id"],
    name: "oderDetailDelivery",
    component: DeliveryScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivery,
  },
  {
    path: ["/order/transit/:shippingGroupId/:id"],
    name: "oderDetailTransit",
    component: TransitScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.transit,
  },
  {
    path: ["/order/in_transit_for_reception/:shippingGroupId/:id"],
    name: "oderDetailTransit",
    component: OrderDetailScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.transit,
  },

  {
    path: ["/order/in_transit_for_reception_opl/:shippingGroupId/:id"],
    name: "oderDetailTransit",
    component: OrderDetailScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.transit,
  },

  {
    path: ["/order/pickup/:shippingGroupId/:id"],
    name: "oderDetailPickup",
    component: PickupScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.pickup,
  },
  {
    path: ["/order/delivered/:shippingGroupId/:id"],
    name: "oderDetailDelivered",
    component: DeliveredScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivered,
  },
  {
    path: ["/order/closed/:shippingGroupId/:id"],
    name: "oderDetailClosed",
    component: ClosedScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.closed,
  },
  {
    path: ["/order/canceled/:shippingGroupId/:id"],
    name: "oderDetailCanceled",
    component: CanceledScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.canceled,
  },
  {
    path: ["/order/rejected/:shippingGroupId/:id"],
    name: "oderDetailRejected",
    component: CanceledScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.rejected,
  },
  {
    path: ["/order/pending_reversa/:shippingGroupId/:id"],
    name: "oderDetailPendingReversa",
    component: ReversaScreen,
    exact: true,
  },
  {
    path: ["/order/pickup_reversa/:shippingGroupId/:id"],
    name: "oderDetailPickupReversa",
    component: PickupReservaScreen,
    exact: true,
  },
  {
    path: ["/order/transit_reversa/:shippingGroupId/:id"],
    name: "oderDetailTransitReversa",
    component: TransitReversaScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.transit_reversa,
  },
  {
    path: ["/order/delivered_reversa/:shippingGroupId/:id"],
    name: "oderDetailDeliveredReversa",
    component: DeliveredScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivered_reversa,
  },
  {
    path: ["/order/canceled_reversa/:shippingGroupId/:id"],
    name: "oderDetailCanceledReversa",
    component: CanceledScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.canceled_reversa,
  },
  {
    path: "/search/:query/:optionFilter",
    name: "SearchResultsPage",
    component: SearchResultsScreen,
    exact: true,
  },

  {
    path: "/report",
    name: "ReportPage",
    component: ReportPage,
    exact: true,
  },

  {
    path: "/page/transfer",
    name: "TransferScreen",
    component: TransferScreen,
    exact: true,
  },

  {
    path: "/page/manifest",
    name: "ManifestScreen",
    component: ManifestScreen,
    exact: true,
  },
  {
    path: "/contractor/dashboard",
    name: "ContractorDashboardScreen",
    component: ContractorDashboardScreen,
    exact: true,
  },
  {
    path: "/contractor/:type/order/:status",
    name: "ContractorOrderPage",
    component: ContractorOrderScreen,
    exact: true,
  },
  {
    path: "/contractor/:type",
    name: "ContractorSubStatusScreen",
    component: ContractorSubStatusScreen,
    exact: true,
  },
  {
    path: ["/order/reception/:shippingGroupId/:id/new"],
    name: "oderContractorReceptionNewScreen",
    component: ContractorReceptionNewScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.transit,
  },
  {
    path: ["/order/reception/:shippingGroupId/:id/incomplete"],
    name: "oderContractorReceptionOtherScreen",
    component: ContractorReceptionOtherScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivered,
  },
  {
    path: ["/order/reception/:shippingGroupId/:id/complete"],
    name: "oderContractorReceptionOtherScreen",
    component: ContractorReceptionOtherScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivered,
  },
  {
    path: ["/order/installation/:shippingGroupId/:id/new"],
    name: "oderContractorInstallationNewScreen",
    component: ContractorInstallationNewScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivered,
  },
  {
    path: ["/order/installation/:shippingGroupId/:id/incomplete"],
    name: "oderContractorInstallationIncompleteScreen",
    component: ContractorInstallationIncompleteScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivered,
  },
  {
    path: ["/order/installation/:shippingGroupId/:id/complete"],
    name: "oderContractorInstallationCompleteScreen",
    component: ContractorInstallationCompleteScreen,
    exact: true,
    statusOrder: EShippinggroupStatus.delivered,
  },
  {
    path: "/contractor/search/:query/:optionFilter",
    name: "ContractorSearchResultsPage",
    component: ContractorSearchResultsScreen,
    exact: true,
  },
  {
    path: "*",
    name: "notFound",
    component: ErrorHandler,
    exact: false,
  },
]

export default RouteListWom
